import styled from "styled-components"
export const ProjectPageHeader = styled.div`
  width: 100%;
  height: 100px;
  background: transparent;
  grid-area: 1 / 1 / 2 / 2;
`
